import { Model } from '@vuex-orm/core'

export default class Email extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'emails'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      candidate_id: this.attr(null),
      job_id: this.attr(null),
      type: this.attr(null),
      subject: this.attr(null),
      shurttext: this.attr(null),
      body: this.attr(null),
      body_media: this.attr(null),
      read: this.attr(null),
      from: this.attr(null),
      to: this.attr(null),
      cc: this.attr(null),
      bcc: this.attr(null),
      attachments_media: this.attr(null),
      send_type: this.attr(null),
      send_at: this.attr(null),
      delivery_status: this.attr(null),
      delivery_notification: this.attr(null),
      deliveryError: this.attr(null),
      created_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Email.js